export default "__VITE_ASSET__CGTE59NI__"